import { apiBaseURL } from '../../constants';
import apiConfig from '../../config/apiConfig';

// Thin pass-through thunk (axios promise returned untouched).
export const exchangeStepUpPassword = (payload) => () => apiConfig.post(apiBaseURL.AUTH_STEP_UP, payload)
